export default __webpack_public_path__ + "static/media/me-pixel.758e60ee.png";